import { uid } from "@resamare/functions";

export const SECTION_PREFIX = `section ${uid(5)}`;
